import React from 'react'
import PropTypes from 'prop-types'
import { ModalContext } from 'src/contexts'
import { required } from 'src/services'
import { useHandler } from 'src/hooks'
import { PaperPlaneIcon } from 'src/components'
import { LabeledInput } from '../../inputs'
import ModalBlock from '../ModalBlock'
import ModalToolbar from '../ModalToolbar'
import { ButtonIcon } from '../../buttons'
import { LocalizedText } from '../../intl'

const InputModal = ({
  input: Input,
  disabled,
  onSubmit,
  validate,
  value: initialValue = '',
  inputProps,
  buttonProps,
  ...props
}) => {
  const { close } = ModalContext.use()
  const [value, onChange] = React.useState(initialValue)
  const canSubmit = React.useMemo(() => (validate ? validate(value) : !required(value)), [validate, value])
  const submit = useHandler(e => {
    e.preventDefault()
    if (value) {
      close()
      return onSubmit && onSubmit(value)
    }
  })
  return (
    <ModalBlock
      as="form"
      onSubmit={submit}
      padding=".5rem"
      toolbar={
        <ModalToolbar>
          <ButtonIcon
            type="submit"
            icon={PaperPlaneIcon}
            disabled={!canSubmit}
            onClick={submit}
            color="secondary-light"
            // eslint-disable-next-line react/no-children-prop
            children={<LocalizedText id="WEB_SEND" />}
            {...buttonProps}
          />
        </ModalToolbar>
      }
      {...props}
    >
      <Input disabled={disabled} autoFocus value={value} onChange={onChange} {...inputProps} />
    </ModalBlock>
  )
}

InputModal.defaultProps = {
  input: LabeledInput,
}

InputModal.propTypes = {
  value: PropTypes.any,
  validate: PropTypes.func,
  onSubmit: PropTypes.func,
  input: PropTypes.any,
  disabled: PropTypes.bool,
  inputProps: PropTypes.object,
  buttonProps: PropTypes.object,
}

export default InputModal
